import { createContext } from 'react'

export const OrgInfoContext = createContext(null)